module.exports = __webpack_public_path__ + "img/heading_no.af9eb0f1.svg";